module.exports = __webpack_public_path__ + "img/option-close.1ad1e016.svg";